import MobileValidateDialog from './src/mobile-validate-dialog';

export default MobileValidateDialog;
